import axios from 'axios'
import store from '@/store/'
import global from '../util/globalVar'
import { delCookie } from '../util/util'

require('./interface')

function spliceURL(params) {
    let url = ''
    for (const k in params) {
        const value = params[k] !== undefined ? params[k] : ''
        url += `&${k}=${value}`
    }
    return url ? url.substring(1) : ''
}

const instance = axios.create({
    method: 'GET',
    params: {
        lang: global.lang,
        region: global.region,
        translate: ''
    }
})

// 添加请求拦截器
instance.interceptors.request.use(
    config => {
        // 处理restful接口{}号内变量问题
        const arr = config.url.match(/{(.+?)}/g)
        if (arr && arr.length) {
            config.url = config.url._p(Object.assign({}, config.data, config.params))
            arr.forEach(key => {
                key = key.substring(1, key.length - 1)
                config.data && delete config.data[key]
                config.params && delete config.params[key]
            })
        }
        if (config.baseURL === '/strapi/') {
            delete config.params.lang
            delete config.params.region
            delete config.params.translate
        }
        return config
    },
    error => Promise.reject(error)
)

// 添加响应拦截器
instance.interceptors.response.use(
    res => {
        if (res.data && res.data.code === 121) {
            delCookie('loginUser')
            store.state.isLogin = false
            // window.location.href = '/mobile/cn/sc/login/'
            return res
        }
        if (res.config.baseURL === '/strapi/') {
            const { url, params } = res.config
            // const cmsSession = JSON.parse(sessionStorage.getItem('owf_cms_api_session') || '{}')
            const cmsSession = {}
            const key = `${url}?${spliceURL(params)}`
            cmsSession[key] = res && res.data
            // sessionStorage.setItem('owf_cms_api_session', JSON.stringify(cmsSession))
            return cmsSession[key]
        }
        return res
    },
    error => Promise.reject(error)
)

function urlHandler(url, options) {
    let method = 'get'
    let baseURL = '/sf-service-owf-web/service/'

    if (url.startsWith('post:')) {
        method = 'post'
        url = url.replace('post:', '')
    }

    if (url.endsWith(':new')) {
        baseURL = '/sf-service-core-web/service/'
        url = url.replace(':new', '')
    }

    if (url.indexOf('http:') > -1 || url.indexOf('https:') > -1) {
        baseURL = ''
    }

    if (url.endsWith(':cms')) {
        baseURL = '/strapi/'
        url = url.replace(':cms', '')
    }

    return function (opts) {
        if (baseURL === '/strapi/') {
            // eslint-disable-next-line object-curly-newline
            opts = opts || {}
            opts.params = {
                ...opts.params,
                _locale: 'zh-CN'
            }
            // const cmsSession = JSON.parse(sessionStorage.getItem('owf_cms_api_session') || '{}')
            const cmsSession = {}
            const key = `${baseURL}${url}?${spliceURL(opts.params)}`
            // eslint-disable-next-line no-prototype-builtins
            const exclude = ['general-switches']
            if (cmsSession.hasOwnProperty(key) && !exclude.includes(url)) {
                return Promise.resolve(cmsSession[key])
            }
        }
        return instance(
            Object.assign(
                {
                    method,
                    baseURL,
                    url
                },
                options,
                opts
            )
        )
    }
}

const ajax = {}
Object.keys(window.urlConfigs).forEach(k => {
    const v = window.urlConfigs[k]
    if (typeof v === 'string') {
        ajax[k] = urlHandler(v)
    } else if (typeof v === 'object') {
        ajax[k] = urlHandler(v[0], v[1])
    }
})

export default ajax



// WEBPACK FOOTER //
// ./src/api/ajax.js